import { ReadReceiptsStatisticValuesDTO } from './read-receipts-statistic-values.dto';

export class ReadReceiptsStatisticsDTO {
    
    designatedTotal: number;

    values: Array<ReadReceiptsStatisticValuesDTO>;

}
